import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBannerIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
			fill: "#FFD6CD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
			fill: "url(#paint0_linear_56_31662)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 13C19 14.1046 18.1046 15 17 15C15.8954 15 15 14.1046 15 13C15 11.8954 15.8954 11 17 11C18.1046 11 19 11.8954 19 13Z",
			fill: "#FFF1EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20C18 18.8954 18.8954 18 20 18C21.1046 18 22 18.8954 22 20Z",
			fill: "#FFF1EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27 13C27 14.1046 26.1046 15 25 15C23.8954 15 23 14.1046 23 13C23 11.8954 23.8954 11 25 11C26.1046 11 27 11.8954 27 13Z",
			fill: "#FFF1EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 20C30 21.1046 29.1046 22 28 22C26.8954 22 26 21.1046 26 20C26 18.8954 26.8954 18 28 18C29.1046 18 30 18.8954 30 20Z",
			fill: "#FFF1EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.0004 16.5723H12C11.7348 16.5723 11.4804 16.6776 11.2929 16.8652C11.1054 17.0527 11 17.307 11 17.5723V30.5723L15 26.5723H24C24.2652 26.5723 24.5196 26.4669 24.7071 26.2794C24.8946 26.0918 25 25.8375 25 25.5723V22.9998H23V24.5723H14.17L13 25.7423V18.5723H15.7782L15.0004 16.5723Z",
			fill: "#FFF1EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25.6102 13.4363L21.4573 19.2504H27.9999V20.7504H19.5054L16.3105 13.2958L17.6893 12.7049L20.1643 18.4799L24.3896 12.5645L25.6102 13.4363Z",
			fill: "#FFF1EE"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_56_31662",
			x1: 0,
			y1: 0,
			x2: 48.1258,
			y2: 17.0103,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#FFA663" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .515625,
					stopColor: "#FF7557"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E37BD3"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgBannerIcon);
export { ForwardRef as ReactComponent };
